module.exports = __webpack_public_path__ + "img/icon-category-motorhome.7c8ad1bb.png";